export default __webpack_public_path__ + "static/media/exchange.338545cc.svg";